// extracted by mini-css-extract-plugin
export default {"vacation":"MaskSize_vacation__2doDf","projectTime":"MaskSize_projectTime__1wRu9"};